var texts = {
  en: {
    proplatCalculator: {
      title: 'Price Calculator',
      subtitle: 'Calculate the FOB price of your products',
      tabs: {
        calculator: 'Calculator',
        history: 'History'
      },
      sections: {
        numericData: 'Numeric Data',
        options: 'Options & Results'
      },
      form: {
        unitPrice: 'Unit Price per Box',
        boxesPerPallet: 'Boxes per Pallet',
        totalPallets: 'Total Pallets',
        freight: 'Freight',
        customsFee: 'Customs Fee',
        inspectionCost: 'Inspection Cost (USD)',
        inOutRate: 'In/Out Rate per Pallet',
        takeRate: 'Take Rate / Margin (%)',
        exchangeRate: 'Exchange Rate (MXN per 1 USD)',
        logisticsCostOverride: 'Logistics Cost Override',
        notes: 'Notes',
        notesPlaceholder: 'Add notes about this calculation...'
      },
      options: {
        operationType: 'Operation Type',
        export: 'Export',
        exportDesc: 'Shipment abroad',
        import: 'Import',
        importDesc: 'Reception from abroad',
        unitMeasure: 'Unit of Measure',
        boxes: 'Boxes',
        boxesDesc: 'Enter total boxes directly',
        pallets: 'Pallets',
        palletsDesc: 'Boxes per pallet x pallets',
        totalBoxes: 'Total Boxes',
        productType: 'Product Type',
        useOverride: 'Use manual logistics cost',
        useOverrideHint: 'Override the calculated logistics cost with a manual value'
      },
      products: {
        fruits: 'Fruits',
        vegetables: 'Vegetables',
        mixed: 'Mixed'
      },
      results: {
        title: 'Calculation Result',
        subtitle: 'Detailed cost breakdown',
        priceFOBWithMargin: 'FOB Price with Margin',
        priceFOBWithoutMargin: 'FOB Price without Margin',
        priceWithoutLogistics: 'Price without Logistics',
        totalBoxes: 'Total Boxes',
        totalTruck: 'Total Truck (FOB)',
        logisticsBreakdown: 'Logistics Breakdown',
        inOutPerBox: 'In/Out per Box',
        customsPerBox: 'Customs per Box',
        freightPerBox: 'Freight per Box',
        logisticsCostPerBox: 'Logistics Cost per Box',
        unitPriceUSD: 'Unit Price (USD)',
        manualOverride: 'Manual Override',
        emptyState: 'Fill in the unit price and pallets to see the result'
      },
      buttons: {
        save: 'Save Calculation',
        update: 'Update Calculation',
        cancel: 'Cancel',
        clear: 'Clear'
      },
      history: {
        empty: 'No saved calculations',
        emptyHint: 'Calculations you save will appear here for you to review or edit',
        deleteTitle: 'Delete calculation?',
        deleteConfirm: 'This action cannot be undone. The calculation will be permanently deleted.',
        deleteBtn: 'Delete',
        detailTitle: 'Calculation Details',
        date: 'Date',
        type: 'Type',
        product: 'Product',
        boxes: 'Boxes',
        fobPerBox: 'FOB/Box',
        totalTruck: 'Total Truck',
        actions: 'Actions'
      },
      messages: {
        requiredFields: 'Unit price, boxes per pallet and total pallets are required',
        saved: 'Calculation saved successfully',
        updated: 'Calculation updated successfully'
      }
    }
  },
  sp: {
    proplatCalculator: {
      title: 'Calculadora de Precios',
      subtitle: 'Calcula el precio FOB de tus productos',
      tabs: {
        calculator: 'Calculadora',
        history: 'Historial'
      },
      sections: {
        numericData: 'Datos Numéricos',
        options: 'Opciones y Resultados'
      },
      form: {
        unitPrice: 'Precio Unitario por Caja',
        boxesPerPallet: 'Cajas por Pallet',
        totalPallets: 'Total de Pallets',
        freight: 'Flete',
        customsFee: 'Costo Aduanal',
        inspectionCost: 'Costo de Inspección (USD)',
        inOutRate: 'Tarifa In/Out por Pallet',
        takeRate: 'Take Rate / Margen (%)',
        exchangeRate: 'Tipo de Cambio (MXN por 1 USD)',
        logisticsCostOverride: 'Costo Logístico Manual',
        notes: 'Notas',
        notesPlaceholder: 'Agrega notas sobre este cálculo...'
      },
      options: {
        operationType: 'Tipo de Operación',
        export: 'Exportación',
        exportDesc: 'Envío al exterior',
        import: 'Importación',
        importDesc: 'Recepción del exterior',
        unitMeasure: 'Unidad de Medida',
        boxes: 'Cajas',
        boxesDesc: 'Ingresar total de cajas directamente',
        pallets: 'Pallets',
        palletsDesc: 'Cajas por pallet x pallets',
        totalBoxes: 'Total de Cajas',
        productType: 'Tipo de Producto',
        useOverride: 'Usar costo logístico manual',
        useOverrideHint: 'Reemplazar el costo logístico calculado con un valor manual'
      },
      products: {
        fruits: 'Frutas',
        vegetables: 'Verduras',
        mixed: 'Mixto'
      },
      results: {
        title: 'Resultado del Cálculo',
        subtitle: 'Desglose detallado de costos',
        priceFOBWithMargin: 'Precio FOB con Margen',
        priceFOBWithoutMargin: 'Precio FOB sin Margen',
        priceWithoutLogistics: 'Precio sin Logística',
        totalBoxes: 'Total de Cajas',
        totalTruck: 'Total Camión (FOB)',
        logisticsBreakdown: 'Desglose Logístico',
        inOutPerBox: 'In/Out por Caja',
        customsPerBox: 'Aduana por Caja',
        freightPerBox: 'Flete por Caja',
        logisticsCostPerBox: 'Costo Logístico por Caja',
        unitPriceUSD: 'Precio Unitario (USD)',
        manualOverride: 'Override Manual',
        emptyState: 'Completa el precio unitario y los pallets para ver el resultado'
      },
      buttons: {
        save: 'Guardar Cálculo',
        update: 'Actualizar Cálculo',
        cancel: 'Cancelar',
        clear: 'Limpiar'
      },
      history: {
        empty: 'No hay cálculos guardados',
        emptyHint: 'Los cálculos que guardes aparecerán aquí para que puedas consultarlos o editarlos',
        deleteTitle: '¿Eliminar cálculo?',
        deleteConfirm: 'Esta acción no se puede deshacer. El cálculo será eliminado permanentemente.',
        deleteBtn: 'Eliminar',
        detailTitle: 'Detalles del Cálculo',
        date: 'Fecha',
        type: 'Tipo',
        product: 'Producto',
        boxes: 'Cajas',
        fobPerBox: 'FOB/Caja',
        totalTruck: 'Total Camión',
        actions: 'Acciones'
      },
      messages: {
        requiredFields: 'El precio unitario, cajas por pallet y total de pallets son obligatorios',
        saved: 'Cálculo guardado exitosamente',
        updated: 'Cálculo actualizado exitosamente'
      }
    }
  }
};

export default texts;
